import React, { useState } from 'react';
import { useParams } from 'react-router';
import { createShareLink } from '../../firebase/utils/createShareLink';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/configureStore';

//Components
import SideBarMenu from '../sidebarMenu/SideBarMenu';

//Types
import { IOrganizationPublic } from '../../types/organization';

//MaterialUI
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { Button, Dialog, DialogTitle, Slider } from '@material-ui/core';

import Box from '@material-ui/core/Box';
import { RightSidebar } from '../fieldBlocks/RightSidebar';
import { useHasFieldblocksAccess } from '../fieldBlocks/useHasFieldblocksAccess';
import { BreadCrumb } from '../navbars/BreadCrumb';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      position: 'relative',
    },
    breadCrumb: {
      marginRight: 'auto',
      paddingLeft: theme.spacing(2),
    },
    breadCrumbContainer: {
      position: 'relative',
      color: 'white',
    },
    dialog: {
      width: 300,
    },
    title: {
      position: 'absolute',
      left: 50,
      right: 50,
    },
  })
);

type Params = {
  phase1Id: string;
  phase2Id: string;
  orgId: string;
};

export default function MapNavbar() {
  const classes = useStyles();
  const { orgId, phase1Id, phase2Id }: Params = useParams();
  const [period, setPeriod] = useState(0);
  const [inShareLink, setInShareLink] = useState(false);
  //const history = useHistory();

  const orgPublicInfo: IOrganizationPublic = useSelector(
    (state: RootState) => state.organization.publicInfo
  );

  const { hasFieldblocksAccess } = useHasFieldblocksAccess();

  const onCreateClick = () => {
    createShareLink(orgId, phase1Id, phase2Id, period, window.location.origin)
      .then((link: string) => {
        alert('Your link is: ' + link + ', valid for ' + period + ' days');
        setInShareLink(false);
      })
      .catch((e) => {
        console.log('Impossible to create shareLink');
        setInShareLink(false);
      });
  };

  const valuetext = (value: number) => {
    setPeriod(value);
    return `${value}days`;
  };

  return (
    <div className={classes.root}>
      <BreadCrumb position={'absolute'} />

      <AppBar position='fixed'>
        <Toolbar variant='dense'>
          <SideBarMenu />
          <div className={classes.title}>
            <Typography
              variant='h6'
              color='inherit'
              aria-label='Organization_Name'
              align='center'
              noWrap
            >
              {orgPublicInfo.shortOrganizationName}
            </Typography>
            {/* <div className={classes.titleText}>
            </div> */}
          </div>

          <Box marginLeft='auto'>
            {hasFieldblocksAccess && <RightSidebar />}
          </Box>
        </Toolbar>
      </AppBar>

      {inShareLink && (
        <Dialog
          onClose={() => setInShareLink(false)}
          aria-labelledby='simple-dialog-title'
          open={inShareLink}
        >
          <DialogTitle id='simple-dialog-title'>How long?</DialogTitle>
          <Slider
            defaultValue={0}
            getAriaValueText={valuetext}
            aria-labelledby='discrete-slider'
            valueLabelDisplay='auto'
            step={1}
            marks
            min={0}
            max={30}
          />
          <Button variant='outlined' color='primary' onClick={onCreateClick}>
            <FormattedMessage id='app.create' defaultMessage='Criar' />
          </Button>
        </Dialog>
      )}
    </div>
  );
}
